import { render, staticRenderFns } from "./StudentSignIn.vue?vue&type=template&id=070471b1&scoped=true"
import script from "./StudentSignIn.vue?vue&type=script&lang=js"
export * from "./StudentSignIn.vue?vue&type=script&lang=js"
import style0 from "./StudentSignIn.vue?vue&type=style&index=0&id=070471b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070471b1",
  null
  
)

export default component.exports